<template>
    <div class="modal" :class="{'modal-hidden':!value}">
        <transition name="fade">
            <div v-show="value" class="modal-mask" @click="close"></div>
        </transition>
        <div class="modal-wrap" :class="'modal-'+size">
            <div class="modal-content">
                <div class="modal-header">
                    <slot name="header">{{title}}</slot>
                    <a href="javascript:;" @click="close">
                        <Icon type="close-round"></Icon>
                    </a>
                </div>
                <div class="modal-body">
                    <slot>这是内容</slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                        <Button type="ghost" @click="close">{{$t('cancel_btn')}}</Button>
                        <Button type="primary" @click="submit" style="color: white;">{{$t('determine_btn')}}</Button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    export default {
        data () {
            return {}
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: '标题'
            },
            size: {
                type: String,
                default: 'middle'
            },
            spinShow:false
        },
        methods: {
            close () {
                this.$emit('input', false)
                this.$emit('on-cancel')
            },
            submit () {
                this.$emit('on-ok')
            }
        },
        mounted () {
            if ($(window).height() < 771) {
                $('.modal-wrap').css("top", "5%")
            }
            if ($(window).height() < 648) {
                $(".addr_modal").css({
                    "height": "370",
                    "overflow": "scroll"
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../scss/components/modal";
</style>



// WEBPACK FOOTER //
// Modal.vue?782d66e7